"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spl = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const common_1 = require("../common");
const entity_1 = require("../entity");
const marshmallow_1 = require("../marshmallow");
const token_1 = require("../token");
const layout_1 = require("./layout");
// https://github.com/solana-labs/solana-program-library/tree/master/token/js/client
class Spl {
    static getAssociatedTokenAccount({ mint, owner }) {
        return spl_token_1.Token.getAssociatedTokenAddress(common_1.ASSOCIATED_TOKEN_PROGRAM_ID, common_1.TOKEN_PROGRAM_ID, mint, owner);
    }
    static makeCreateAssociatedTokenAccountInstruction({ mint, associatedAccount, owner, payer, }) {
        return spl_token_1.Token.createAssociatedTokenAccountInstruction(common_1.ASSOCIATED_TOKEN_PROGRAM_ID, common_1.TOKEN_PROGRAM_ID, mint, associatedAccount, owner, payer);
    }
    // https://github.com/solana-labs/solana-program-library/blob/master/token/js/client/token.js
    static makeCreateWrappedNativeAccountInstructions({ connection, owner, payer, amount, commitment, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const instructions = [];
            // Allocate memory for the account
            const balanceNeeded = yield connection.getMinimumBalanceForRentExemption(layout_1.SPL_ACCOUNT_LAYOUT.span, commitment);
            // Create a new account
            const newAccount = web3_js_1.Keypair.generate();
            instructions.push(web3_js_1.SystemProgram.createAccount({
                fromPubkey: payer,
                newAccountPubkey: newAccount.publicKey,
                lamports: balanceNeeded,
                space: layout_1.SPL_ACCOUNT_LAYOUT.span,
                programId: common_1.TOKEN_PROGRAM_ID,
            }));
            // Send lamports to it (these will be wrapped into native tokens by the token program)
            instructions.push(web3_js_1.SystemProgram.transfer({
                fromPubkey: payer,
                toPubkey: newAccount.publicKey,
                lamports: (0, entity_1.parseBigNumberish)(amount).toNumber(),
            }));
            // Assign the new account to the native token mint.
            // the account will be initialized with a balance equal to the native token balance.
            // (i.e. amount)
            instructions.push(this.makeInitAccountInstruction({
                mint: (0, common_1.validateAndParsePublicKey)(token_1.WSOL.mint),
                tokenAccount: newAccount.publicKey,
                owner,
            }));
            return { newAccount, instructions };
        });
    }
    static makeInitMintInstruction({ mint, decimals, mintAuthority, freezeAuthority = null, }) {
        return spl_token_1.Token.createInitMintInstruction(common_1.TOKEN_PROGRAM_ID, mint, decimals, mintAuthority, freezeAuthority);
    }
    static makeMintToInstruction({ mint, dest, authority, amount, multiSigners = [], }) {
        const LAYOUT = (0, marshmallow_1.u64)("amount");
        const data = Buffer.alloc(LAYOUT.span);
        LAYOUT.encode((0, entity_1.parseBigNumberish)(amount), data);
        return spl_token_1.Token.createMintToInstruction(common_1.TOKEN_PROGRAM_ID, mint, dest, authority, multiSigners, spl_token_1.u64.fromBuffer(data));
    }
    static makeInitAccountInstruction({ mint, tokenAccount, owner, }) {
        return spl_token_1.Token.createInitAccountInstruction(common_1.TOKEN_PROGRAM_ID, mint, tokenAccount, owner);
    }
    static makeTransferInstruction({ source, destination, owner, amount, multiSigners = [], }) {
        const LAYOUT = (0, marshmallow_1.u64)("amount");
        const data = Buffer.alloc(LAYOUT.span);
        LAYOUT.encode((0, entity_1.parseBigNumberish)(amount), data);
        return spl_token_1.Token.createTransferInstruction(common_1.TOKEN_PROGRAM_ID, source, destination, owner, multiSigners, spl_token_1.u64.fromBuffer(data));
    }
    static makeCloseAccountInstruction({ tokenAccount, owner, payer, multiSigners = [], }) {
        return spl_token_1.Token.createCloseAccountInstruction(common_1.TOKEN_PROGRAM_ID, tokenAccount, payer, owner, multiSigners);
    }
}
exports.Spl = Spl;
//# sourceMappingURL=spl.js.map